/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import React, { useFlux, withMemo } from 'fierry/react.old';

import Grid from 'astro/client/map/grid';

import * as Mask from 'astro/react/map/mask/stripe';


const Component = (props) =>
(
  <defs>
    <Mask.VerticalStripe {...props} />
    <Mask.HorizontalStripe {...props} />

    <Mask.DecreaseStripe {...props} />
    <Mask.IncreaseStripe {...props} />

    <Mask.IncreaseDashStripe {...props} />
  </defs>
);


export default withMemo((props) =>
{
  const [ grid ] = useFlux(Grid);

  return <Component {...props} grid = {grid} />;
});
